import React, { useState } from 'react';
import { template as tmpl } from './RegisterContainer.tmpl';
import { Link } from 'react-router-dom';

const RegisterContainerLogic = (props) => {
    const initProps = props;
    const [isRequestAccount, setIsRequestAccount] = useState(false);
    return (
        tmpl && tmpl({ ...initProps, isRequestAccount, setIsRequestAccount })
    );
};

class RegisterContainer extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const initProps = {
            title: 'Register',
            ...this.props
        };
        return <RegisterContainerLogic {...initProps} />;
    }
}

export { RegisterContainer };
